/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AccessRequestResponse,
    AccessRequestResponseFromJSON,
    AccessRequestResponseToJSON,
} from '../models/AccessRequestResponse';
import {
    type AccessRequestResponsePagedResult,
    AccessRequestResponsePagedResultFromJSON,
    AccessRequestResponsePagedResultToJSON,
} from '../models/AccessRequestResponsePagedResult';
import {
    type AccessRequestSearchRequest,
    AccessRequestSearchRequestFromJSON,
    AccessRequestSearchRequestToJSON,
} from '../models/AccessRequestSearchRequest';
import {
    type AccessRequestUpdateAccessRequest,
    AccessRequestUpdateAccessRequestFromJSON,
    AccessRequestUpdateAccessRequestToJSON,
} from '../models/AccessRequestUpdateAccessRequest';
import {
    type AccessRequestUpdateStatusNotificationPreviewResponse,
    AccessRequestUpdateStatusNotificationPreviewResponseFromJSON,
    AccessRequestUpdateStatusNotificationPreviewResponseToJSON,
} from '../models/AccessRequestUpdateStatusNotificationPreviewResponse';
import {
    type AccessRequestUpdateStatusRequest,
    AccessRequestUpdateStatusRequestFromJSON,
    AccessRequestUpdateStatusRequestToJSON,
} from '../models/AccessRequestUpdateStatusRequest';
import {
    type AccessRequestUpdateStatusResponse,
    AccessRequestUpdateStatusResponseFromJSON,
    AccessRequestUpdateStatusResponseToJSON,
} from '../models/AccessRequestUpdateStatusResponse';
import {
    type ApprovedAccessResponsePagedResult,
    ApprovedAccessResponsePagedResultFromJSON,
    ApprovedAccessResponsePagedResultToJSON,
} from '../models/ApprovedAccessResponsePagedResult';
import {
    type ApprovedAccessSearchRequest,
    ApprovedAccessSearchRequestFromJSON,
    ApprovedAccessSearchRequestToJSON,
} from '../models/ApprovedAccessSearchRequest';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';

export interface ApiAccessRequestsApprovedPostRequest {
    approvedAccessSearchRequest: ApprovedAccessSearchRequest;
}

export interface ApiAccessRequestsIdAccessPutRequest {
    id: number;
    accessRequestUpdateAccessRequest: AccessRequestUpdateAccessRequest;
}

export interface ApiAccessRequestsIdStatusPreviewPostRequest {
    id: number;
    accessRequestUpdateStatusRequest: AccessRequestUpdateStatusRequest;
}

export interface ApiAccessRequestsIdStatusPutRequest {
    id: number;
    accessRequestUpdateStatusRequest: AccessRequestUpdateStatusRequest;
}

export interface ApiAccessRequestsSearchesPostRequest {
    accessRequestSearchRequest: AccessRequestSearchRequest;
}

export interface GetAccessRequestByIdRequest {
    id: number;
}

/**
 * 
 */
export class AccessRequestsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiAccessRequestsApprovedPost without sending the request
     */
    async apiAccessRequestsApprovedPostRequestOpts(requestParameters: ApiAccessRequestsApprovedPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['approvedAccessSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'approvedAccessSearchRequest',
                'Required parameter "approvedAccessSearchRequest" was null or undefined when calling apiAccessRequestsApprovedPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/approved`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprovedAccessSearchRequestToJSON(requestParameters['approvedAccessSearchRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsApprovedPostRaw(requestParameters: ApiAccessRequestsApprovedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovedAccessResponsePagedResult>> {
        const requestOptions = await this.apiAccessRequestsApprovedPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovedAccessResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsApprovedPost(requestParameters: ApiAccessRequestsApprovedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovedAccessResponsePagedResult> {
        const response = await this.apiAccessRequestsApprovedPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsIdAccessPut without sending the request
     */
    async apiAccessRequestsIdAccessPutRequestOpts(requestParameters: ApiAccessRequestsIdAccessPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAccessRequestsIdAccessPut().'
            );
        }

        if (requestParameters['accessRequestUpdateAccessRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestUpdateAccessRequest',
                'Required parameter "accessRequestUpdateAccessRequest" was null or undefined when calling apiAccessRequestsIdAccessPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/{id}/access`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestUpdateAccessRequestToJSON(requestParameters['accessRequestUpdateAccessRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsIdAccessPutRaw(requestParameters: ApiAccessRequestsIdAccessPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponse>> {
        const requestOptions = await this.apiAccessRequestsIdAccessPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsIdAccessPut(requestParameters: ApiAccessRequestsIdAccessPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponse> {
        const response = await this.apiAccessRequestsIdAccessPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsIdStatusPreviewPost without sending the request
     */
    async apiAccessRequestsIdStatusPreviewPostRequestOpts(requestParameters: ApiAccessRequestsIdStatusPreviewPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAccessRequestsIdStatusPreviewPost().'
            );
        }

        if (requestParameters['accessRequestUpdateStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestUpdateStatusRequest',
                'Required parameter "accessRequestUpdateStatusRequest" was null or undefined when calling apiAccessRequestsIdStatusPreviewPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/{id}/status/preview`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestUpdateStatusRequestToJSON(requestParameters['accessRequestUpdateStatusRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsIdStatusPreviewPostRaw(requestParameters: ApiAccessRequestsIdStatusPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestUpdateStatusNotificationPreviewResponse>> {
        const requestOptions = await this.apiAccessRequestsIdStatusPreviewPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestUpdateStatusNotificationPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsIdStatusPreviewPost(requestParameters: ApiAccessRequestsIdStatusPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestUpdateStatusNotificationPreviewResponse> {
        const response = await this.apiAccessRequestsIdStatusPreviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsIdStatusPut without sending the request
     */
    async apiAccessRequestsIdStatusPutRequestOpts(requestParameters: ApiAccessRequestsIdStatusPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAccessRequestsIdStatusPut().'
            );
        }

        if (requestParameters['accessRequestUpdateStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestUpdateStatusRequest',
                'Required parameter "accessRequestUpdateStatusRequest" was null or undefined when calling apiAccessRequestsIdStatusPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/{id}/status`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestUpdateStatusRequestToJSON(requestParameters['accessRequestUpdateStatusRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsIdStatusPutRaw(requestParameters: ApiAccessRequestsIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestUpdateStatusResponse>> {
        const requestOptions = await this.apiAccessRequestsIdStatusPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestUpdateStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsIdStatusPut(requestParameters: ApiAccessRequestsIdStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestUpdateStatusResponse> {
        const response = await this.apiAccessRequestsIdStatusPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsSearchesPost without sending the request
     */
    async apiAccessRequestsSearchesPostRequestOpts(requestParameters: ApiAccessRequestsSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessRequestSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestSearchRequest',
                'Required parameter "accessRequestSearchRequest" was null or undefined when calling apiAccessRequestsSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestSearchRequestToJSON(requestParameters['accessRequestSearchRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsSearchesPostRaw(requestParameters: ApiAccessRequestsSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponsePagedResult>> {
        const requestOptions = await this.apiAccessRequestsSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsSearchesPost(requestParameters: ApiAccessRequestsSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponsePagedResult> {
        const response = await this.apiAccessRequestsSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccessRequestById without sending the request
     */
    async getAccessRequestByIdRequestOpts(requestParameters: GetAccessRequestByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccessRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccessRequestByIdRaw(requestParameters: GetAccessRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponse>> {
        const requestOptions = await this.getAccessRequestByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAccessRequestById(requestParameters: GetAccessRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponse> {
        const response = await this.getAccessRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
